import React from 'react/addons';
import cx from 'classnames';
import SelectOne from 'ofs/forms/inputs/simple-choice';

import {gettext, interpolate} from 'ofs/i18n';

import http from 'http';
http.post = require('http-post');

const messages = {
  HEADING: gettext('Request a change'),
  CATEGORY_LABEL: gettext('I\'d like to change:'),
  DETAILS_LABEL: gettext('Please let us know which details need to be updated:'), 
  DETAILS_PLACEHOLDER: gettext('Enter your request here'),
  SUBMITTING: gettext('Submitting...'),
  SUCCESS_HEADING: gettext('Thank you for your enquiry'),
  SUCCESS_MESSAGE: gettext('We\'ll get back to you soon.'),
  SUBMIT: gettext('Submit'),
  ERROR_HEADING: gettext('Something went wrong'),
  ERROR_DEFAULT_MESSAGE: gettext('There was a problem with your request. Call us on %(guest_services_phone)s to speak with our Front Desk.'),
  REQUIRED: gettext('This field is required'),
};

var RequestChangeForm = React.createClass({
  getInitialState () {
    return {
      status: 'default',
      isValid: true,
    };
  },

  isValid (data) {
    if (data['change_reasons'].length) {
      return true;
    } else {
      this.setState({isValid: false});
      return false;
    }
  }, 

  onSubmit (event) {
    event.preventDefault();
    const reasons = this.refs.changeReasons.getDOMNode();

    // category is the input node in SelectOne with
    // the name 'change_category'
    const category = Array.prototype.slice.call(this.refs.changeCategory.getDOMNode().children)
      .find(child => {
        return child.name === 'change_category';
      });

    var data = {
      'change_reasons': reasons.value,
      'change_category': category.value || 'other',
    };
    
    if (this.isValid(data)) {
      http.post(this.props.formData.url, data, (response) => {
        if (response.statusCode !== 200) {
          this.setState({
            status: 'error',
            error: null,
          });
        } else {
          this.setState({status: 'success'});
        }
      }).on('error', () => {
        this.setState({
          status: 'error',
        });
      });
      this.setState({status: 'submitting'});
    } 
  },

  render () {
    const validationClasses = cx({
      'ofs-Input__ErrorMessage': true,
      'u-hide': this.state.isValid,
    });
    const errorMessage = interpolate(messages.ERROR_DEFAULT_MESSAGE, {
      guest_services_phone: this.props.formData.guestServicesPhone
    }, true);

    var {status} = this.state;

    var {changeFormFields} = this.props.formData;
    changeFormFields = changeFormFields.map(field => ({value: field[0], name: field[1]}));

    return (
      <section className="ofs-EnquiryForm">
        <h2 className="ofs-EnquiryForm__Title">{messages.HEADING}</h2>
        {status === 'default' &&
          <form className="ofs-Form -form--condensed" onSubmit={this.onSubmit}>
            <div className="ofs-Form__Field">
              <label className="ofs-Form__Label">{messages.CATEGORY_LABEL}</label>
              <SelectOne options={changeFormFields} name="change_category" ref="changeCategory"/>
            </div>
            <div className="ofs-Form__Field">
              <label className="ofs-Form__Label">{messages.DETAILS_LABEL}</label>
              <textarea className="ofs-Input ofs-Input--textarea" defaultValue={messages.PLACEHOLDER} ref="changeReasons"/>
              <label className={validationClasses}>{messages.REQUIRED}</label>
            </div>
            <div className="ofs-Form__Field">
              <button className="ofs-Button">{messages.SUBMIT}</button>
            </div>
          </form>
        }
        {status === 'submitting' &&
          <div className="ofs-EnquiryForm__Message">
            <h3>{messages.SUBMITTING}</h3>
          </div>
        }
        {status === 'success' &&
          <div className="ofs-EnquiryForm__Message">
            <h3>{messages.SUCCESS_HEADING}</h3>
            <p>{messages.SUCCESS_MESSAGE}</p>
          </div>
        }
        {status === 'error' &&
          <div className="ofs-EnquiryForm__Message">
            <h3>{messages.ERROR_HEADING}</h3>
            <p>{errorMessage}</p>
          </div>
        }
      </section>
    );
  },
});

export default RequestChangeForm;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/guests/views/RequestChangeForm.jsx
 **/